import LanguageCode from '../types/language';

/**
 * Maps app language codes to Azure Translator API codes.
 * - tl → fil (Tagalog is not a supported Azure code; Filipino is the equivalent)
 * - zh → zh-Hans (Simplified Chinese; zh-Hant is a future follow-up if Traditional is added)
 * - hy, so, vi, ht pass through unchanged (verified supported by Azure Translator v3.0)
 */
export function toTranslatorLanguageCode(language: LanguageCode): string {
	switch (language) {
		case 'tl':
			return 'fil';
		case 'zh':
			return 'zh-Hans';
		default:
			return language;
	}
}
